import NextActivityCard from "@components/Activity/ActivityCheckOut/NextActivityCard/NextActivityCard";

export default NextActivityCard;
